export const INGREDIENT_VALIDATION_STATUSES = {
  VALID: 'valid',
  INVALID: 'invalid',
}
